module.exports = __webpack_public_path__ + "static/media/wemake.d42c5f24.png";